

//预约系统
import Bespeak from "./bespeak";
//充值中心
import Recharge from "./recharge";
//fedex 费率
import Fedex from "./fedex";
//库存
import Inventory from "./inventory";
//调拨
import Allotment from "./allotment";
import Product from "./product";
import Accountmanage from "./accountmanage";
//基本设置
import Setting from "./setting";
//任务中心
import Tasks from "./tasks";
//账单
import Bill from "./bill";
//入库
import Report from "./report";
//npm
import Credit from "./credit";
//我的账户
import Account from "./account";

//入库计划单
import Inbound from "./inbound";
//测算
import Chargescalc from "./chargescalc";
//销售退货
import Salesreturns from "./salesreturns";
//基础数据
import Basicdata from "./basicdata";
//头程物流
import Headlogistics from "./headlogistics";
//事务单
import Workorder from "./workorder";

//索赔单
import Reimbursement from "./reimbursement";

//承运商燃油附加费
import Fuelsurcharge from "./fuelsurcharge";

// 销毁单
import Destory from './destory';
//物流看板
import Logisticspanel from "./logisticspanel";
// 客户仓容分配
import StorageAllocation from './storageallocation';
// 快递包裹
import expressPackage from './expresspackage';
// 库存异动
import inventoryadjustment from './inventoryadjustment';
// 移库
import warehousemove from './warehousemove';

// 杂入杂出
import misc from './misc';
// 物流系统
import logistics from './logistics';
// 节假日管理
import holiday from './holiday';
// 客户仓容分配
import CostBilling from './costbilling';

import Newbigaccount from './newbigaccount';
// 承运商账号
import CarrierAccount from './carrieraccount';
// 补货周期
import ReplenishmentCycle from './replenishmentcycle'; 
// 转运计划
import Transfer from './transfer';

// 库存异动通知
import StockNotify from './stocknotify';

export default [
    {   //组面板
        path: "",
        name: "homePanel",
        component: () => import(/* webpackChunkName: "home" */ "@components/homepage/home.vue"),
        meta: {
            bread: false
        }
    },
    {   //公告列表
        path: "/homenewlist",
        name: "homenewList",
        component: () => import(/* webpackChunkName: "home" */ "@components/homepage/homelist/newslist"),
        // meta: {
        //     bread: false
        // }
    },
    ...Bespeak,
    ...Recharge,
    ...Fedex,
    ...Allotment,
    ...Accountmanage,
    ...Setting,
    ...Tasks,
    ...Bill,
    ...Product,
    ...Inventory,
    ...Report,
    ...Credit,
    ...Account,
    ...Inbound,
    ...Chargescalc,
    ...Salesreturns,
    ...Basicdata,
    ...Headlogistics,
    ...Logisticspanel,
    ...Workorder,
    ...Reimbursement,
    ...Fuelsurcharge,
    ...Destory,
    ...StorageAllocation,
    ...expressPackage,
    ...CostBilling,
    ...Newbigaccount,
    ...misc,
    ...inventoryadjustment,
    ...warehousemove,
    ...logistics,
    ...holiday,
    ...CarrierAccount,
    ...ReplenishmentCycle,
    ...Transfer,
    ...StockNotify
]
